<template>
  <div class="bg-white-border p-3 main-theme text-body">
    <div v-if="live">
      <b-row>
        <b-col
          ><b-form-group label="Name">
            <b-form-input
              v-model="live.name"
              placeholder="live name"
            ></b-form-input>
            <small class="text-danger" v-if="isValidated && !live.name"
              >กรุณากรอกข้อมูลให้ถูกต้อง</small
            >
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Select Facebook Post">
            <b-form-select v-model="live.postId">
              <b-form-select-option
                v-for="(post, postIndex) in posts"
                :key="postIndex"
                :value="post.id"
                >{{ post.message }}</b-form-select-option
              >
            </b-form-select>
          </b-form-group></b-col
        >
      </b-row>

      <div
        class="d-flex justify-content-between align-items-center p-3 border"
        style="background-color:#e2dff3"
      >
        <span class="unit-font text-break">การตั้งค่าคีย์เวิร์ด</span>
        <span class="text-break overview-number">
          <span
            style="cursor:pointer;
     color:blue;
     text-decoration:underline;"
            @click="addReply"
            >+เพิ่มคีย์เวิร์ดการตอบกลับ</span
          >
        </span>
      </div>
      <div
        v-for="(reply, replyIndex) in live.replyList"
        :key="replyIndex"
        class="mb-3 bg-white p-3 border"
      >
        <b-row>
          <b-col>
            <b-form-group label="Keyword Group*">
              <b-form-input
                v-model="reply.keywordGroupName"
                placeholder="Keyword group name"
              ></b-form-input>
              <small
                class="text-danger"
                v-if="isValidated && !reply.keywordGroupName"
                >กรุณากรอกข้อมูลให้ถูกต้อง</small
              >
            </b-form-group></b-col
          >
          <b-col>
            <div class="text-right">
              <span class="text-break">
                <b-button
                  variant="link"
                  class="text-danger px-1 py-0"
                  @click="removeReply(replyIndex)"
                >
                  <font-awesome-icon
                    icon="trash-alt"
                    title="Delete"
                  /> </b-button
              ></span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Keyword*">
              <b-form-tags
                input-id="tags-pills"
                v-model="reply.keyword"
                tag-variant="secondary"
                tag-pills
                size="lg"
                separator=" "
                placeholder=""
              ></b-form-tags>
              <small
                class="text-danger"
                v-if="isValidated && !reply.keyword.length > 0"
                >กรุณากรอกข้อมูลให้ถูกต้อง</small
              >
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 1
              )
            "
          >
            <!-- {{
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 1
              )
            }} -->
            <div
              class="bg-light p-3 rounded text-black"
              v-if="
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 1
                ) != null
              "
            >
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        ).status
                      "
                    >
                      Comment type
                    </b-form-checkbox>
                  </b-form-group>
                </span>
                <span class="text-break">
                  <b-form-select
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).replyTypeId
                    "
                    @change="
                      onChangeChannelReplyTypeId(
                        $event,
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        )
                      )
                    "
                  >
                    <b-form-select-option :value="1">Text</b-form-select-option>
                    <b-form-select-option :value="2"
                      >Image(s)</b-form-select-option
                    >
                  </b-form-select>
                </span>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 1
                  ).replyTypeId == 1
                "
              >
                <b-form-group
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).textImage[0]
                  "
                >
                  <b-form-textarea
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).textImage[0].text
                    "
                    placeholder="Text here..."
                    rows="3"
                  ></b-form-textarea>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 1
                        ).textImage[0].text
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </b-form-group>
              </div>

              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 1
                  ).replyTypeId == 2
                "
              >
                <ImageUpload
                  :textImages="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).textImage
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 1
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 1
                      ).textImage.length > 0
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
              </div>
            </div>
          </b-col>

          <b-col
            v-if="
              reply.channelTypeList.find(
                (channelType) => channelType.replyChannelId == 2
              )
            "
          >
            <div class="bg-light text-black  p-3 rounded">
              <!-- {{
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 2
                )
              }} -->
              <div class="d-flex justify-content-between align-items-center">
                <span class="unit-font text-break">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).status
                      "
                      style="color:black"
                    >
                      Direct Message
                    </b-form-checkbox>
                  </b-form-group>
                </span>
                <span class="text-break">
                  <b-form-select
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).replyTypeId
                    "
                    @change="
                      onChangeChannelReplyTypeId(
                        $event,
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        )
                      )
                    "
                  >
                    <b-form-select-option
                      v-for="(messageReplyType,
                      messageReplyTypeIndex) in messageReplyTypes"
                      :key="messageReplyTypeIndex"
                      :value="messageReplyType.id"
                      >{{ messageReplyType.name }}</b-form-select-option
                    >
                  </b-form-select>
                </span>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 1
                "
              >
                <b-form-group
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                >
                  <b-form-textarea
                    v-model="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text
                    "
                    placeholder="Text here..."
                    rows="3"
                  ></b-form-textarea>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].text
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </b-form-group>
              </div>
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 2
                "
              >
                <ImageUpload
                  :textImages="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage.length > 0
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
              </div>
              <!-- typetextImage -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 4
                "
              >
                <div
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                >
                  <TextImageInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0]
                    "
                    :textImage="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0]
                    "
                  />
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].text |
                          !reply.channelTypeList.find(
                            (channelType) => channelType.replyChannelId == 2
                          ).textImage[0].imageUrl
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
              </div>
              <!-- typebutton -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 3
                "
              >
                <b-form-textarea
                  v-model="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0].text
                  "
                  placeholder="Text here..."
                  rows="3"
                ></b-form-textarea>
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >
                <div
                  class="mt-3"
                  style="cursor:pointer;
                       color:blue;  
                       text-decoration:underline;"
                  @click="
                    addButton(
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      )
                    )
                  "
                >
                  +เพิ่มปุ่ม
                </div>
                <div
                  v-for="(button, buttonIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).buttons"
                  :key="buttonIndex"
                >
                  <TextButtonInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status !== undefined
                    "
                    :isValidated="isValidated"
                    :button="button"
                    :index="buttonIndex"
                    :status="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status
                    "
                    :buttons="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).buttons
                    "
                  />
                </div>
              </div>
              <!-- typeflex -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 5
                "
              >
                <TextImageInput
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                  :textImage="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).textImage[0]
                  "
                />
                <small
                  class="text-danger"
                  v-if="
                    reply.channelTypeList.find(
                      (channelType) => channelType.replyChannelId == 2
                    ).status &&
                      isValidated &&
                      !reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).textImage[0].text |
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).textImage[0].imageUrl
                  "
                  >กรุณากรอกข้อมูลให้ถูกต้อง</small
                >

                <div class="mt-3">
                  <span
                    style="cursor:pointer;
                       color:blue;  
                       text-decoration:underline;"
                    @click="
                      addButton(
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        )
                      )
                    "
                    >+เพิ่มปุ่ม</span
                  >
                </div>
                <div
                  v-for="(button, buttonIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).buttons"
                  :key="buttonIndex"
                >
                  <TextButtonInput
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status !== undefined
                    "
                    :isValidated="isValidated"
                    :button="button"
                    :index="buttonIndex"
                    :status="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status
                    "
                    :buttons="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).buttons
                    "
                  />
                </div>
              </div>
              <!-- typeproduct -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 6
                "
              >
                <b-button
                  variant="outline-primary"
                  @click="$bvModal.show('bv-modal-product')"
                  >Add product</b-button
                >
                <div>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products.length > 0
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
                <b-modal id="bv-modal-product" size="xl" hide-footer>
                  <template #modal-title>
                    Select Product
                  </template>
                  <div class="d-block text-center">
                    <SelectProduct
                      :confirmProduct="selectProduct"
                      :products="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products
                      "
                    />
                  </div>
                </b-modal>
                <div
                  class="bg-white rounded my-3 p-3"
                  v-for="(product, productIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).products"
                  :key="productIndex"
                >
                  <div
                    class="d-flex justify-content-between align-items-center p-3"
                  >
                    <img
                      :src="product.imageUrl"
                      :alt="product.name"
                      width="80px"
                    />
                    <span class="unit-font text-break"
                      >product {{ product.name }}
                    </span>
                    <span class="text-break">
                      <b-button
                        variant="link"
                        class="text-danger px-1 py-0"
                        @click="
                          removeProduct(
                            reply.channelTypeList.find(
                              (channelType) => channelType.replyChannelId == 2
                            ).products,
                            productIndex
                          )
                        "
                      >
                        <font-awesome-icon
                          icon="trash-alt"
                          title="Delete"
                        /> </b-button
                    ></span>
                  </div>
                </div>
              </div>
              <!-- typeaddtocart -->
              <div
                v-if="
                  reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).replyTypeId == 7
                "
              >
                <b-button
                  variant="outline-primary"
                  @click="$bvModal.show('bv-modal-product')"
                  >Add product</b-button
                >
                <div>
                  <small
                    class="text-danger"
                    v-if="
                      reply.channelTypeList.find(
                        (channelType) => channelType.replyChannelId == 2
                      ).status &&
                        isValidated &&
                        !reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products.length > 0
                    "
                    >กรุณากรอกข้อมูลให้ถูกต้อง</small
                  >
                </div>
                <b-modal id="bv-modal-product" size="xl" hide-footer>
                  <template #modal-title>
                    Select Product
                  </template>
                  <div class="d-block text-center">
                    <SelectProduct
                      :confirmProduct="selectProduct"
                      :products="
                        reply.channelTypeList.find(
                          (channelType) => channelType.replyChannelId == 2
                        ).products
                      "
                    />
                  </div>
                </b-modal>
                <div
                  class="bg-white rounded my-3 p-3"
                  v-for="(product, productIndex) in reply.channelTypeList.find(
                    (channelType) => channelType.replyChannelId == 2
                  ).products"
                  :key="productIndex"
                >
                  <div
                    class="d-flex justify-content-between align-items-center p-3"
                  >
                    <img
                      :src="product.imageUrl"
                      :alt="product.name"
                      width="80px"
                    />
                    <span class="unit-font text-break"
                      >product {{ product.name }}
                    </span>
                    <span class="text-break">
                      <b-button
                        variant="link"
                        class="text-danger px-1 py-0"
                        @click="
                          removeProduct(
                            reply.channelTypeList.find(
                              (channelType) => channelType.replyChannelId == 2
                            ).products,
                            productIndex
                          )
                        "
                      >
                        <font-awesome-icon
                          icon="trash-alt"
                          title="Delete"
                        /> </b-button
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <small
          class="text-danger"
          v-if="
            isValidated &&
              !(
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 1
                ).status |
                reply.channelTypeList.find(
                  (channelType) => channelType.replyChannelId == 2
                ).status
              )
          "
          >กรุณากรอกข้อมูลให้ถูกต้อง</small
        >
      </div>
    </div>
    <div class="text-right mt-3">
      <b-btn @click="save" class="px-3">Save</b-btn>
    </div>
    <template>
      <div>
        <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')"
            >Open Modal</b-button
          > -->

        <b-modal
          id="bv-modal-example"
          hide-footer
          no-close-on-backdrop
          hide-header
        >
          <template #modal-title> </template>
          <div class="d-block text-center">
            <h3>ยังไม่ได้เชื่อม Facebook Page</h3>
            กรุณาเชื่อม Facebook Page ก่อนใช้งานเมนู Live
          </div>
          <b-button class="mt-3" block @click="goSettingPage" variant="primary"
            >ไปยังหน้าเชื่อม Facebook Page</b-button
          >
        </b-modal>
      </div>
    </template>
    <b-modal id="bv-modal-loading" hide-footer no-close-on-backdrop hide-header>
      <template #modal-title> </template>
      <div class="text-center">
        <b-spinner class="mr-3" label="Spinning"></b-spinner>Loading...
      </div>
    </b-modal>
  </div>
</template>

<script>
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ImageUpload from "./Component/ImageUpload";
import TextImageInput from "./Component/TextImage";
import TextButtonInput from "./Component/TextButton";
import SelectProduct from "./Component/SelectProduct";
export default {
  name: "LiveEdit",
  components: {
    ModalAlert,
    ModalAlertError,
    ModalAlertConfirm,
    ImageUpload,
    TextImageInput,
    TextButtonInput,
    SelectProduct,
  },
  data() {
    return {
      id: this.$route.params.id,
      postTypeId: this.$route.params.postTypeId,
      commentReplyTypes: [],
      messageReplyTypes: [],
      live: null,
      pageId: null,
      posts: [],
      isValidated: false,
    };
  },
  async created() {
    await this.checkLoginPage();
    if (!this.isLoginPage) {
      this.$bvModal.show("bv-modal-example");
      return;
    }
    this.getCommentReplyTypes();
    this.getMessageReplyTypes();
    if (this.id == 0) {
      this.setDefault();
    } else {
      await this.getDetail();
      this.setDefault();
    }
    this.getFacebooklist();
  },
  methods: {
    async getFacebooklist() {
      await this.axios
        .post(`${this.$baseUrl}/livePost/Facebooklist`, {
          postId: this.live.postId,
          postTypeId: this.postTypeId,
          paging: {
            pageNo: 1,
            perPage: 9999,
          },
        })
        .then((data) => {
          console.log("get facebook list", data);
          if (data.result == 1) {
            this.posts = data.detail.posts;
          }
        });
    },
    goSettingPage() {
      this.$router.push({ path: `/setting` }).catch(() => {});
    },
    async checkLoginPage() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/checkLoginPage`)
        .then((data) => {
          console.log("check login page", data);
          if (data.result == 1) {
            this.isLoginPage = data.detail != 0;
            if (this.isLoginPage) {
              this.pageId = data.detail.pageId;
            }
          }
        });
    },
    getProducts: async function(products, productIds) {
      await this.axios
        .post(`${this.$baseUrl}/product/list`, {
          search: "",
          pageNo: 1,
          perPage: productIds.length,
          productIdList: productIds,
          Categories: [],
        })
        .then((data) => {
          console.log("get products", data);
          if (data.result == 1) {
            data.detail.dataList.forEach((product) => {
              product["productId"] = product.id;
            });
            products.length = 0;
            products.push(...data.detail.dataList);
          }
        });
    },
    async save() {
      this.isValidated = true;
      if (!this.validate()) {
        alert("กรุณากรอกข้อมูลให้ถูกต้อง");
        return;
      }
      var body = JSON.parse(JSON.stringify(this.live));
      body.replyList = body.replyList.map((reply) => {
        reply.channelTypeList = reply.channelTypeList.filter(
          (channelType) => channelType.status
        );
        return reply;
      });
      if (this.live.id == 0) {
        this.live.postCreatedTime = this.posts.find(
          (item) => item.id == this.live.postId
        ).createdTime;
      }
      this.$bvModal.show("bv-modal-loading");

      await this.axios
        .post(`${this.$baseUrl}/livePost/save`, body)
        .then((data) => {
          console.log("save", data);
          this.$bvModal.hide("bv-modal-loading");

          if (data.result == 1) {
            this.$router.push({ path: `/live` }).catch(() => {});
          } else {
            alert("save fail", data.message);
          }
        });
    },
    validate() {
      if (!this.live.name) {
        return false;
      }
      var isHaveError = this.live.replyList.some((reply) => {
        if (!reply.keywordGroupName) {
          return true;
        }
        if (!reply.keyword.length > 0) {
          return true;
        }
        if (
          reply.channelTypeList.every(
            (channelType) => channelType.status == false
          )
        ) {
          return true;
        }

        var commentChannelType = reply.channelTypeList.find(
          (channelType) => channelType.replyChannelId == 1
        );
        if (commentChannelType) {
          if (commentChannelType.status) {
            switch (commentChannelType.replyTypeId) {
              case 1:
                // text
                if (!commentChannelType.textImage[0].text) {
                  return true;
                }
                break;
              case 2:
                // image
                if (!commentChannelType.textImage.length > 0) {
                  return true;
                }
                break;
            }
          }
        }

        var messageChannelType = reply.channelTypeList.find(
          (channelType) => channelType.replyChannelId == 2
        );

        if (messageChannelType.status) {
          switch (messageChannelType.replyTypeId) {
            case 1:
              // text
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              break;
            case 2:
              // image
              if (!messageChannelType.textImage.length > 0) {
                return true;
              }
              break;
            case 4:
              // text image
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              if (!messageChannelType.textImage[0].imageUrl) {
                return true;
              }
              break;
            case 3:
              // text button
              if (
                messageChannelType.buttons.some((button) => {
                  if (!button.sortOrder) {
                    return true;
                  }
                  if (!button.label) {
                    return true;
                  }
                  if (!button.data) {
                    return true;
                  }
                  return false;
                })
              ) {
                return true;
              }
              break;
            case 5:
              // flex
              if (!messageChannelType.textImage[0].text) {
                return true;
              }
              if (!messageChannelType.textImage[0].imageUrl) {
                return true;
              }
              if (
                messageChannelType.buttons.some((button) => {
                  if (!button.sortOrder) {
                    return true;
                  }
                  if (!button.label) {
                    return true;
                  }
                  if (!button.data) {
                    return true;
                  }
                  return false;
                })
              ) {
                return true;
              }
              break;
            case 6:
              // product
              if (!messageChannelType.products.length > 0) {
                return true;
              }
            case 7:
              // add to cart
              if (!messageChannelType.products.length > 0) {
                return true;
              }
              break;
            default:
            // code block
          }
        }
        return false;
      });
      console.log("isHaveError", isHaveError);
      return !isHaveError;
    },
    getDetail: async function() {
      await this.axios
        .get(`${this.$baseUrl}/livePost/${this.id}`)
        .then((data) => {
          console.log("get live detail", data);
          if (data.result == 1) {
            this.live = data.detail;
          }
        });
    },
    removeReply(replyIndex) {
      this.live.replyList.splice(replyIndex, 1);
    },
    removeProduct(products, productIndex) {
      products.splice(productIndex, 1);
    },
    getCommentReplyTypes: function() {
      this.axios
        .get(`${this.$baseUrl}/masterdata/LiveReplyType/1`)
        .then((data) => {
          if (data.result == 1) {
            this.commentReplyTypes = data.detail;
          }
        });
    },
    getMessageReplyTypes: function() {
      this.axios
        .get(`${this.$baseUrl}/masterdata/LiveReplyType/2`)
        .then((data) => {
          if (data.result == 1) {
            this.messageReplyTypes = data.detail;
          }
        });
    },
    addDefaultReplyChannel(reply, replyChannelId) {
      reply.channelTypeList.push({
        id: 0,
        status: false,
        replyTypeId: 1,
        replyChannelId: replyChannelId,
        textImage: [{ text: null, imageUrl: null }],
        products: [],
        buttons: [],
      });
    },
    addReply() {
      var reply = {
        replyId: 0,
        limit: 0,
        keywordGroupName: "",
        keyword: [],
        channelTypeList: [],
      };
      this.addDefaultReplyChannel(reply, 1);
      this.addDefaultReplyChannel(reply, 2);
      this.live.replyList.push(reply);
    },
    setDefault() {
      if (this.live) {
        this.setDefaultReply();
      } else {
        this.live = {
          id: 0,
          pageId: this.pageId,
          postTypeId: this.postTypeId,
          postId: "",
          postName: "",
          postImageUrl: "",
          name: "",
          statusId: 0,
          replyList: [],
        };
        this.addReply();
      }
      console.log("live", this.live);
    },
    setDefaultReply() {
      this.live.replyList.forEach((reply) => {
        var commentChannel = reply.channelTypeList.find(
          (channel) => channel.replyChannelId == 1
        );
        if (commentChannel != null) {
          commentChannel["status"] = true;
        } else {
          this.addDefaultReplyChannel(reply, 1);
        }
        var messageChannel = reply.channelTypeList.find(
          (channel) => channel.replyChannelId == 2
        );
        if (messageChannel) {
          messageChannel["status"] = true;
          if ([6, 7].includes(messageChannel.replyTypeId)) {
            console.log(messageChannel.products);
            var productIds = messageChannel.products.map(
              (product) => product.productId
            );
            this.getProducts(messageChannel.products, productIds);
          }
        } else {
          this.addDefaultReplyChannel(reply, 2);
        }
      });
    },
    selectProduct(products, selectedProducts) {
      this.getProducts(products, selectedProducts);
      this.$bvModal.hide("bv-modal-product");
    },
    onChangeChannelReplyTypeId(event, channel) {
      channel.textImage = [];
      channel.products = [];
      channel.buttons = [];
      console.log(channel);
      if ([1, 3, 4, 5].includes(event)) {
        channel.textImage.push({
          text: null,
          imageUrl: null,
        });
      }
      if ([3, 5].includes(event)) {
        this.addButton(channel);
      }
    },
    addButton(channel) {
      channel.buttons.push({
        label: null,
        data: null,
        actionTypeId: 1,
        buttonTypeId: 1,
        sortOrder: 1,
      });
    },
  },
};
</script>

<style></style>
